import React from "react";

function NbyulaAvatarIcon({ className = "" }) {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_7919_41317)">
        <path fill="url(#paint0_linear_7919_41317)" d="M0 0H100V100H0z"></path>
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M54.099 59.423c-4.063-1.745-7.529-4.085-13.074-9.255C30.458 40.37 25.328 29.127 29.67 25.115c2.697-2.537 10.983-2.447 21.461 5.2"
        ></path>
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="4"
          d="M58.15 38.391c7.97 9.026 12.72 18.943 9.11 22.579-1.418 1.419-3.74 1.746-6.607 1.148"
        ></path>
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="4"
          d="M43.48 45.3c7.874-10.945 17.275-15.822 22.657-13.107 5.646 2.834 3.714 14.91-4.268 26.928-7.981 12.02-19.098 19.485-24.744 16.651-4.669-2.347-4.253-11.514.539-21.215"
        ></path>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_7919_41317"
          x1="-30"
          x2="144.366"
          y1="-14"
          y2="34.507"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.014" stopColor="#E201BE"></stop>
          <stop offset="0.384" stopColor="#5F2EEA"></stop>
          <stop offset="0.997" stopColor="#00BFDB"></stop>
        </linearGradient>
        <clipPath id="clip0_7919_41317">
          <path fill="#fff" d="M0 0H100V100H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default NbyulaAvatarIcon;
